import { useRef, useState } from "react";

import MenuHeader from "./menu-header";
import NavMenuItems from "./nav-menu-items";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";

const Sidebar = props => {
    // ** Props
    const { menu, menuData, ability } = props;

    // ** States
    const [groupOpen, setGroupOpen] = useState([]);
    const [groupActive, setGroupActive] = useState([]);
    const [currentActiveGroup, setCurrentActiveGroup] = useState([]);
    const [activeItem, setActiveItem] = useState(null);

    // ** Menu Hover State
    const [menuHover, setMenuHover] = useState(false);
    // ** Ref
    const shadowRef = useRef(null);

    // ** Function to handle Mouse Enter
    const onMouseEnter = () => {
        setMenuHover(false);
    };
    // ** Scroll Menu
    const scrollMenu = container => {
        if (shadowRef && container.scrollTop > 0) {
            if (!shadowRef.current.classList.contains("d-block")) {
                shadowRef.current.classList.add("d-block");
            }
        } else {
            if (shadowRef.current.classList.contains("d-block")) {
                shadowRef.current.classList.remove("d-block");
            }
        }
    };

    return (
        <div
            className={classnames(
                "main-menu menu-fixed menu-accordion menu-shadow menu-light"
            )}>
            {menu ? (
                menu({ ...props })
            ) : (
                <>
                    <div
                        className="h-100"
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={() => setMenuHover(false)}>
                        <>
                            {/* Vertical Menu Header */}
                            <MenuHeader
                                setGroupOpen={setGroupOpen}
                                menuHover={menuHover}
                                ability={ability}
                                {...props}/>
                            {/* Vertical Menu Header Shadow */}
                            <div className="shadow-bottom" ref={shadowRef}></div>
                            {/* Perfect Scrollbar */}
                            <PerfectScrollbar
                                className="main-menu-content"
                                options={{ wheelPropagation: false }}
                                onScrollY={container => scrollMenu(container)}>
                                <ul className="navigation navigation-main">
                                    <NavMenuItems
                                        items={menuData.panel}
                                        ability={ability}
                                        {...props}
                                        menuData={menuData.panel}
                                        menuHover={menuHover}
                                        groupOpen={groupOpen}
                                        activeItem={activeItem}
                                        groupActive={groupActive}
                                        setGroupOpen={setGroupOpen}
                                        setActiveItem={setActiveItem}
                                        setGroupActive={setGroupActive}
                                        currentActiveGroup={currentActiveGroup}
                                        setCurrentActiveGroup={setCurrentActiveGroup}/>
                                </ul>
                            </PerfectScrollbar>
                        </>
                    </div>
                </>
            )}
            <div className="bottom-navigation border-top-dark">
                <ul className="navigation navigation-main">
                    <NavMenuItems
                        items={menuData.bottomNavigation}
                        ability={ability}
                        {...props}
                        menuData={menuData.bottomNavigation}
                        menuHover={menuHover}
                        groupOpen={groupOpen}
                        activeItem={activeItem}
                        groupActive={groupActive}
                        setGroupOpen={setGroupOpen}
                        setActiveItem={setActiveItem}
                        setGroupActive={setGroupActive}
                        currentActiveGroup={currentActiveGroup}
                        setCurrentActiveGroup={setCurrentActiveGroup}/>
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;
